import { adminHttpClient } from '../commons/adminHttpClient'
import BenefitParticipationDecision from '../../domain/companies/BenefitParticipationDecision'
import { NamedItemInt } from '../../domain/common/namedItem'

export type CompanyUserBenefitDetailsResponse = {
  planPeriodId: string
  planPeriodStartDate: string
  planPeriodEndDate: string
  HasPlanPeriodStarted: boolean
  notificationDate?: string
  maxDateToTakeBenefitParticipationDecision?: string
  isMaxDateToTakeBenefitParticipationDecisionReached: string
  HasNotificationDatePassed: boolean
  productClassId?: string
  isEligible?: boolean
  benefitEligibilityDate?: string
  hasBenefitStarted: boolean
  benefitParticipationDecision: BenefitParticipationDecision
  currentBenefitParticipationDecision: { id: BenefitParticipationDecision; name: string }
  primaryBenefitContact?: PrimaryBenefitContactResponse
  familyStatus?: NamedItemInt
  classDetails?: ProductClassDetails
  terminatedInCurrentPlanPeriod: boolean
}

type PrimaryBenefitContactResponse = {
  id: string
  name: string
  workEmail: string
}

type ProductClassDetails = {
  name: string
  monthlyAllowance: number
  expenseType: NamedItemInt
}
const getCompanyUserBenefitDetails = (planPeriodId: string): Promise<CompanyUserBenefitDetailsResponse> => {
  return adminHttpClient.get(`/Benefit/CompanyUserDetails/${planPeriodId}`, {})
}

export default getCompanyUserBenefitDetails
